import clsx from "clsx";
import { Route, Routes, useLocation } from "react-router-dom";
import Agent from "../pages/agent";
import CreateChase from "../pages/create-chase";
import ChaseList from "../pages/chase-list";
import Dashboard from "../pages/dashboard";
import LeftSidebar from "./left-side-bar";
import Auth from "../pages/auth";
import ResetPassword from "../pages/reset-password";
import MessageTemplates from "../pages/message-templates";
import GraphProvider from "../providers/graphs-provider";
import { useSidebar } from "../store/use-sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import AgentCodeSetupAlert from "./AgentCodeSetupAlert";

function MainComponent() {
  const location = useLocation();
  const { collapsed, toggleMobile } = useSidebar();
  const hideSideBarRoutes = ["createChase", "auth", "reset", "chat"];
  const hideSidebar = hideSideBarRoutes.includes(
    location.pathname.split("/")[1],
  );

  return (
    <GraphProvider>
      <AgentCodeSetupAlert />
      <div className="flex min-h-screen bg-background">
        {!hideSidebar && (
          <div
            className={clsx(
              "sticky top-0 h-screen z-20 shrink-0 transition-[width] duration-300 ease-out smallLaptop:w-0 smallLaptop:sticky",
              collapsed ? "w-[84px]" : "w-[260px]",
            )}
          >
            <LeftSidebar />
          </div>
        )}

        <main
          className={clsx(
            "flex-1 min-w-0 min-h-screen bg-background transition-colors duration-300",
          )}
        >
          {!hideSidebar && (
            <button
              type="button"
              onClick={toggleMobile}
              aria-label="Open menu"
              className="hidden smallLaptop:inline-flex fixed top-4 left-4 z-30 h-10 w-10 items-center justify-center rounded-xl border border-edge bg-surface-elevated text-text-primary shadow-card"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
          )}

          <Routes>
            <Route
              path="/"
              element={
                <GraphProvider>
                  <Dashboard />
                </GraphProvider>
              }
            />
            <Route path="/chaselist" element={<ChaseList />} />
            <Route path="/chase/:id" element={<ChaseList />} />
            <Route path="/my-customers" element={<ChaseList />} />
            <Route path="/customer-archives" element={<ChaseList />} />

            <Route path="/createChase" element={<CreateChase />} />
            <Route path="/agents" element={<Agent />} />
            <Route path="/message-templates" element={<MessageTemplates />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset" element={<ResetPassword />} />
          </Routes>
        </main>
      </div>
    </GraphProvider>
  );
}

export default MainComponent;
